import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Menu, X, Facebook, Instagram, Linkedin } from "lucide-react";
import logoAcesso from "@/assets/logo-acesso-original.png";
import { Button } from "@/components/ui/button";
import PrefetchLink from "@/components/PrefetchLink";

const navItems = [
  { label: "Home", path: "/" },
  { label: "A Empresa", path: "/empresa" },
  { label: "Soluções", path: "/solucoes" },
  { label: "Atuação", path: "/atuacao" },
  { label: "Aplicativo", path: "/aplicativo" },
  { label: "FAQ", path: "/faq" },
  { label: "Contato", path: "/contato" },
];

const socialLinks = [
  { icon: Facebook, href: "https://www.facebook.com/acessogo/", label: "Facebook" },
  { icon: Instagram, href: "https://www.instagram.com/acesso.srv/", label: "Instagram" },
  { icon: Linkedin, href: "https://br.linkedin.com/company/acesso-sistemas-de-seguran%C3%A7a", label: "LinkedIn" },
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/90 backdrop-blur-md border-b border-border">
      <div className="container mx-auto flex items-center justify-between h-16 px-4">
        <PrefetchLink to="/" className="flex items-center gap-2">
          <img src={logoAcesso} alt="Acesso Sistemas de Segurança" className="h-8" width={155} height={32} sizes="155px" decoding="async" />
        </PrefetchLink>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <PrefetchLink
              key={item.path}
              to={item.path}
              onClick={() => window.scrollTo(0, 0)}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                location.pathname === item.path
                  ? "bg-primary text-primary-foreground"
                  : "text-foreground/70 hover:text-foreground hover:bg-muted"
              }`}
            >
              {item.label}
            </PrefetchLink>
          ))}
          <div className="flex items-center gap-1 ml-2">
            {socialLinks.map((s) => (
              <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} className="p-2 text-foreground/50 hover:text-accent transition-colors">
                <s.icon className="h-4 w-4" />
              </a>
            ))}
          </div>
          <Button asChild size="sm" className="ml-1 bg-accent text-accent-foreground hover:bg-accent/90">
            <a href="https://wa.me/5562998313953" target="_blank" rel="noopener noreferrer">
              WhatsApp
            </a>
          </Button>
        </nav>

        {/* Mobile toggle */}
        <button className="md:hidden p-2" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Menu">
          {mobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {/* Mobile nav */}
      {mobileOpen && (
        <nav className="md:hidden bg-background border-b border-border px-4 pb-4 animate-fade-in">
          {navItems.map((item) => (
            <PrefetchLink
              key={item.path}
              to={item.path}
              onClick={() => { setMobileOpen(false); window.scrollTo(0, 0); }}
              className={`block px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                location.pathname === item.path
                  ? "bg-primary text-primary-foreground"
                  : "text-foreground/70 hover:text-foreground hover:bg-muted"
              }`}
            >
              {item.label}
            </PrefetchLink>
          ))}
          <div className="flex items-center justify-center gap-4 mt-3">
            {socialLinks.map((s) => (
              <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} className="text-foreground/50 hover:text-accent transition-colors">
                <s.icon className="h-5 w-5" />
              </a>
            ))}
          </div>
          <Button asChild size="sm" className="mt-2 w-full bg-accent text-accent-foreground hover:bg-accent/90">
            <a href="https://wa.me/5562998313953" target="_blank" rel="noopener noreferrer">
              WhatsApp
            </a>
          </Button>
        </nav>
      )}
    </header>
  );
};

export default Header;
